import { ReactNode } from 'react';

import styles from './ListDivider.module.scss';

interface ListDividerProps {
  label: ReactNode;
}

export const ListDivider = ({ label }: ListDividerProps) => (
  <div className={styles.divider} data-testid="list-divider">
    {label}
  </div>
);
